import moment from 'moment'
import _ from 'lodash'

export const getCurrentEventId = ({ eventList, currentDate, }) => {
  // TODO: base on a UTC date rather than string combo
  let thisDate
  let thisDateString
  let currentEventId
  if (currentDate) {
    thisDateString = moment(currentDate).format('YYYY-MM-DD')
  } else {
    thisDate = new Date()
    thisDateString = moment(thisDate).format('YYYY-MM-DD')
  }
  const sortedEventList = _.orderBy(eventList, ['depart', 'arrive'])
  const eventCount = sortedEventList.length
  const thisMoment = moment(thisDateString)
  sortedEventList.forEach((event, index) => {
    if (
      event.arrive &&
      (moment(thisMoment).isSame(event.arrive) ||
        moment(thisMoment).isAfter(event.arrive))
    ) {
      currentEventId = event.id
    }
    if (
      (event.depart && moment(thisMoment).isSame(event.depart)) ||
      moment(thisMoment).isAfter(event.depart)
    ) {
      currentEventId = event.id
    }
    if (
      index === eventCount - 1 &&
      event.arrive &&
      moment(thisMoment).isAfter(event.arrive)
    ) {
      currentEventId = undefined
    }
  })
  return currentEventId
}

export const getMediaEventDayNum = ({ events, eventId, mediaId, }) => {
  let dayNum,
    thisEvent
  events.forEach((event) => {
    if (event.id === eventId) {
      thisEvent = event
    }
  })
  thisEvent.itinerary.forEach((day, index) => {
    if (day.media) {
      if (day.media.video) {
        if (day.media.video.indexOf(mediaId) > -1) {
          dayNum = index + 1
        }
      }
      if (day.media.blog) {
        if (day.media.blog.indexOf(mediaId) > -1) {
          dayNum = index + 1
        }
      }
    }
  })
  return dayNum
}

export const getMediaEventIds = ({ events, mediaId, }) => {
  // returns an array of events that this media item is used in
  const mediaEventIds = []
  events.forEach((event) => {
    if (event.itinerary) {
      event.itinerary.forEach((day) => {
        if (day.media) {
          if (day.media.video) {
            day.media.video.forEach((videoId) => {
              if (videoId === mediaId) {
                mediaEventIds.push(event.id)
              }
            })
          }
        }
      })
    }
  })
  return mediaEventIds
}

export const getOrderedMediaList = ({ events, type, }) => {
  const mediaList = []
  events.forEach((event) => {
    if (event.itinerary) {
      event.itinerary.forEach((day) => {
        if (day.media) {
          if (day.media[type]) {
            day.media[type].forEach((id) => {
              mediaList.push({
                mediaId: id,
                mediaType: type,
              })
            })
          }
        }
      })
    }
  })
  return mediaList
}

export const getNextPreviousMedia = ({ mediaId, mediaType, events, }) => {
  const mediaList = getOrderedMediaList({ events, type: mediaType, })
  let thisMediaIndex = -1
  mediaList.forEach((mediaItem, index) => {
    if (mediaItem.mediaId === mediaId) {
      thisMediaIndex = index
    }
  })
  if (thisMediaIndex === -1) {
    return undefined
  }
  const nextMedia = mediaList[thisMediaIndex + 1]
  const previousMedia = mediaList[thisMediaIndex - 1]
  return {
    nextMedia,
    previousMedia,
  }
}

export default {
  getOrderedMediaList,
  getNextPreviousMedia,
  getMediaEventDayNum,
  getMediaEventIds,
  getCurrentEventId,
}



// WEBPACK FOOTER //
// ./src/redux/utils.js